import React from 'react';
// import { Route, Switch } from 'react-router';
import { Provider } from 'react-redux';
// import { ConnectedRouter } from 'connected-react-router';
// import history from './utils/history';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from 'react-router-dom';
import { ApolloProvider } from '@apollo/client';

import 'antd/dist/antd.css';
import './App.css';
import './components/Forms/index.css';

import { PersistGate } from 'redux-persist/integration/react';
import { persistStore } from 'redux-persist';

import ProtectedRoute from './ProtectedRoute';
import LoginContainer from './containers/Login';
import store from './store/store';
import apolloClient from './apollo/apollo';

import Employees from './containers/Employees';
import Settings from './containers/Settings';
import RolePermissions from './containers/Settings/RolePermissions';
import Expense from './containers/Expense';
import Payroll from './containers/Payroll';
import Reports from './containers/Reports';

let persistor = persistStore(store);

function App() {
  return (
    <ApolloProvider client={apolloClient}>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <Router>
            <Switch>
              <ProtectedRoute exact path="/" component={Employees} />
              <ProtectedRoute exact path="/settings" component={Settings} />
              <ProtectedRoute
                exact
                path="/settings/permissions"
                component={RolePermissions}
              />
              <ProtectedRoute path="/expense/:tab?/:tab2?" component={Expense} />
              <ProtectedRoute path="/payroll/:tab?/:tab2?" component={Payroll} />
              <ProtectedRoute path="/reports/:tab?" component={Reports} />
              <ProtectedRoute path="/settings/:tab?" component={Settings} />
              <Route path="/login" component={LoginContainer} />
              <Redirect to="/" />
            </Switch>
          </Router>
        </PersistGate>
      </Provider>
    </ApolloProvider>
  );
}

export default App;
